export default "__VITE_PUBLIC_ASSET__fb7bb1c6__"